import { campanaApi } from '../../utils/api';
import {
  getObjectDataAction,
  createObjectDataPending,
  getListDataAction,
  saveObjectDataAction,
  deleteObjectDataAction,
  getListDeletedDataAction,
  createListDataDeletedPending,
  restoreObjectDataAction,
} from '../../utils/DataAction';

export const get = (id) =>
  getObjectDataAction({
    dataName: 'CAMPANA',
    api: campanaApi,
    relUrl: id,
  });

export const getAll = getListDataAction({
  dataName: 'CAMPANA',
  api: campanaApi,
  relUrl: '',
});

export const save = (data) =>
  saveObjectDataAction({
    dataName: 'CAMPANA',
    api: campanaApi,
    relUrl: '',
    data: data,
  });

export const deleted = (id) =>
  deleteObjectDataAction({
    dataName: 'CAMPANA',
    api: campanaApi,
    relUrl: id,
  });

export const getAllDeleted = getListDeletedDataAction({
  dataName: 'CAMPANA',
  api: campanaApi,
  relUrl: 'restore',
});

export const restore = (data) =>
  restoreObjectDataAction({
    dataName: 'CAMPANA',
    api: campanaApi,
    relUrl: 'restore',
    data: data,
  });

export const setPending = createObjectDataPending('CAMPANA');
export const setDeletedPending = createListDataDeletedPending('CAMPANA');
